import { Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardComponents } from "@/features/dashboard/_components/dashboard";
import { ProductForm } from "@/features/dashboard/produtos/components/ProductForm";

export const Route = createFileRoute("/_private/dashboard/_base/produtos/editar/$id/")({
  component: RouteComponent
});

function RouteComponent() {
  const { id } = Route.useParams();

  return (
    <Stack>
      <DashboardComponents.Title>Editar Produto</DashboardComponents.Title>

      <ProductForm id={id} />
    </Stack>
  );
}
